export default "__VITE_ASSET__qbuMjGJb__"